export const Otrsicons: Record<string, string> = {
  chamado: 'i-mdi-ticket',
  empresa: 'i-mdi-domain',
  versao: 'i-mdi-source-branch',
  cliente: 'i-mdi-account-group',
  usuario: 'i-mdi-account-key',
  layout: 'i-mdi-printer',
  sistema: 'i-mdi-application',
  texto: 'i-mdi-text-box-outline',
  chave: 'i-mdi-key'
}

export const Icones: Record<string, string> = {
  suspenso: 'i-mdi-pause-circle-outline',
  externo: 'i-mdi-file-export',
  devolver: 'i-mdi-account-arrow-left',
  opiniao: 'i-mdi-account-arrow-right',
  corrigir: 'i-mdi-file-edit-outline',
  adendo: 'i-mdi-file-plus-outline',
  text: 'i-mdi-text-box-outline',
  fila: 'i-mdi-arrow-right-box',
  changelog: 'i-mdi-history',
  setup: 'i-mdi-cog',
  alerta: 'i-mdi-alert-circle',
  home: 'i-mdi-home',
  left: 'i-mdi-chevron-left',
  right: 'i-mdi-chevron-right',
  down: 'i-mdi-chevron-down',
  up: 'i-mdi-chevron-up',
  enviar: 'i-mdi-send',
  number: 'i-mdi-numeric',
  anamnese: 'i-mdi-file-question',
  ocultar: 'i-mdi-eye-off',
  exibir: 'i-mdi-eye',
  assinatura: 'i-mdi-signature-text',
  chave: 'i-mdi-key',
  empresa: 'i-healthicons-hospital', // i-mdi-building',
  sala: 'i-mdi-home-city',
  usuario: 'i-mdi-account-key',
  funcionario: 'i-mdi-account',
  medico: 'i-mdi-doctor',
  modalidade: 'i-mdi-desktop-mac',
  procedimento: 'i-mdi-monitor-account',
  modelo: 'i-mdi-text-box-outline',
  calendario: 'i-mdi-calendar-month',
  calendario_dia: 'i-mdi-calendar',
  horario: 'i-mdi-clock-outline',
  layout: 'i-mdi-printer-outline',
  scanner: 'i-mdi-scanner',
  sistema: 'i-mdi-application-outline',
  gestao: 'i-mdi-monitor-dashboard',
  prescricao: 'i-mdi-beaker',
  paciente: 'i-mdi-account',
  rota: 'i-mdi-truck-delivery',
  anexo: 'i-mdi-paperclip',
  imagem: 'i-mdi-file-image',
  chat: 'i-mdi-chat',
  procedencia: 'i-mdi-map-marker',
  executante: 'i-healthicons-doctor',
  revisor: 'i-healthicons-doctor-male',
  auditor: 'i-healthicons-doctor-female',
  urgencia: 'i-healthicons-ambulance',
  urgente: 'i-mdi-alert-circle',
  aviso: 'i-mdi-alert-circle-outline',
  confirmacao: 'i-mdi-check-circle-outline',
  cancelamento: 'i-mdi-cancel',
  atendimento: 'i-mdi-account-group',
  clinica: 'i-mdi-hospital-building',
  exame: 'i-mdi-account-file',
  laudo: 'i-mdi-monitor-edit',
  pendencia: 'i-mdi-alert',
  solucao: 'i-mdi-alert-remove',
  achado: 'i-mdi-alert-octagon',
  achadofim: 'i-mdi-alert-octagon-outline',
  dicom: 'i-mdi-image',
  auditoria: 'i-mdi-account-check',
  append: 'i-mdi-plus',
  save: 'i-mdi-content-save',
  delete: 'i-mdi-delete',
  edit: 'i-mdi-pencil',
  cancel: 'i-mdi-cancel',
  close: 'i-mdi-close',
  search: 'i-mdi-magnify',
  print: 'i-mdi-printer',
  download: 'i-mdi-download',
  upload: 'i-mdi-upload',
  laudo_back: 'i-mdi-file-document-arrow-right',
  laudo_cancel: 'i-mdi-file-document-remove',
  laudo_add: 'i-mdi-file-document-plus',
  laudo_del: 'i-mdi-file-document-remove-outline',
  laudo_pdf: 'i-mdi-file-pdf',
  laudo_txt: 'i-mdi-file-document',
  laudo_dif: 'i-mdi-file-compare',
  laudo_fix: 'i-mdi-file-edit',
  laudo_mov: 'i-mdi-transfer',
  laudo_request: 'i-mdi-file-document-plus-outline',
  grupo: 'i-mdi-group',
  bodypart: 'i-mdi-human',
  especialidade: 'i-mdi-stethoscope',
  many2one: 'i-mdi-relation-many-to-one',
  many2many: 'i-mdi-relation-many-to-many',
  one2many: 'i-mdi-relation-one-to-many',
  transfer: 'i-mdi-transfer',
  sla: 'i-mdi-timer-sand',
  password: 'i-mdi-lock',
  acesso: 'i-mdi-boom-gate',
  convenio: 'i-mdi-shield-account',
  plano: 'i-mdi-credit-card-outline',
  material: 'i-mdi-medication',
  material_grupo: 'i-mdi-package-variant',
  unidade: 'i-mdi-ruler',
  estoque: 'i-mdi-store',
  // pendencia: 'i-mdi-alert',
  devolucao: 'i-mdi-account-arrow-left',
  texto: 'i-mdi-touch-text-outline',
  formula: 'i-mdi-function-variant',
  atendimento_ficha: 'i-mdi-account-check',
  atendimento_cancela: 'i-mdi-account-cancel',
  atendimento_finalizar: 'i-mdi-check-circle',
  atendimento_contraste: 'i-mdi-pill',
  pesquisa: 'i-mdi-magnify-plus',
  visualizador: 'i-mdi-monitor-eye',
  finalizar: 'i-mdi-close-circle',
  email: 'i-mdi-email',
  smileHappy: 'i-mdi-emoticon-happy',
  smileSad: 'i-mdi-emoticon-sad',
  smileNeutral: 'i-mdi-emoticon-neutral',
  relogio: 'i-mdi-clock',
  grafico: 'i-mdi-chart-line',
  report: 'i-mdi-file-document-outline',
  questionario: 'i-mdi-file-question',
  janela: 'i-mdi-window-maximize',
  formulario: 'i-mdi-form-textbox',
  dados: 'i-mdi-database',
  sql: 'i-mdi-database-search',
  reconvocacao: 'i-mdi-account-reactivate', // Alterado para um ícone mais apropriado para reconvocação
  revisao: 'i-mdi-file-document-refresh',
  resultado: 'i-mdi-archive-check',
  excel: 'i-mdi-file-excel',
  pdf: 'i-mdi-file-pdf',
  kanban: 'i-mdi-view-dashboard',
  diagram: 'i-mdi-chart-sankey',
  meta: 'i-mdi-target',
  editor: 'i-mdi-file-word',
  online: 'i-mdi-account-check',
  offline: 'i-mdi-account-off',
  escalar: 'i-mdi-arrow-up',
  financeiro_fornecedor: 'i-mdi-account-group',
  financeiro_banco: 'i-mdi-bank',
  financeiro_conta: 'i-mdi-arrow-decision',
  financeiro_centro: 'i-mdi-home-city',
  financeiro_servico: 'i-mdi-toolbox',
  agendamento_bloquear: 'i-mdi-lock',
  agendamento_confirmar: 'i-mdi-check-circle-outline',
  agendamento_cancelar: 'i-mdi-cancel',
  kit: 'i-mdi-package-variant',
  modulo: 'i-mdi-folder-outline'
}

export const iconMapping = {
  'ABORT.BMP': 'x',
  'ALARM.BMP': 'bell',
  'ALARMRNG.BMP': 'bell',
  'ANIMATN.BMP': 'film',
  'ARROW1D.BMP': 'arrow-down',
  'ARROW1DL.BMP': 'arrow-down-left',
  'ARROW1DR.BMP': 'arrow-down-right',
  'ARROW1L.BMP': 'arrow-left',
  'ARROW1R.BMP': 'arrow-right',
  'ARROW1U.BMP': 'arrow-up',
  'ARROW1UL.BMP': 'arrow-up-left',
  'ARROW1UR.BMP': 'arrow-up-right',
  'ARROW2D.BMP': 'arrow-narrow-down',
  'ARROW2L.BMP': 'arrow-narrow-left',
  'ARROW2R.BMP': 'arrow-narrow-right',
  'ARROW2U.BMP': 'arrow-narrow-up',
  'ARROW3D.BMP': 'arrow-narrow-down',
  'ARROW3L.BMP': 'arrow-narrow-left',
  'ARROW3R.BMP': 'arrow-narrow-right',
  'ARROW3U.BMP': 'arrow-narrow-up',
  'BOOKOPEN.BMP': 'book-open',
  'BOOKSHUT.BMP': 'book',
  'BRUSH.BMP': 'paint-brush',
  'BULBOFF.BMP': 'light-bulb-off',
  'BULBON.BMP': 'light-bulb-on',
  'CALCULAT.BMP': 'calculator',
  'CALENDAR.BMP': 'calendar',
  'CDDRIVE.BMP': 'cd',
  'CHECK.BMP': 'check',
  'CLEAR.BMP': 'x',
  'CLOCK.BMP': 'clock',
  'COMPMAC.BMP': 'desktop-computer',
  'COMPPC1.BMP': 'desktop-computer',
  'COMPPC2.BMP': 'desktop-computer',
  'COPY.BMP': 'duplicate',
  'CRDFILE1.BMP': 'document',
  'CRDFILE2.BMP': 'document',
  'CRDFILE3.BMP': 'document',
  'CUT.BMP': 'scissors',
  'DATE.BMP': 'calendar',
  'DAY.BMP': 'sun',
  'DELETE.BMP': 'trash',
  'DIRECTRY.BMP': 'folder',
  'DOCSINGL.BMP': 'document',
  'DOCSTACK.BMP': 'clipboard-document-list',
  'DOOROPEN.BMP': 'logout',
  'DOORSHUT.BMP': 'login',
  'EDIT.BMP': 'pencil',
  'ERASE.BMP': 'eraser',
  'EXPORT.BMP': 'arrow-circle-right',
  'FCABOPEN.BMP': 'folder-open',
  'FCABSHUT.BMP': 'folder',
  'FDRAWER1.BMP': 'archive',
  'FDRAWER2.BMP': 'archive',
  'FIELD.BMP': 'field',
  'FILECLOS.BMP': 'x',
  'FILENEW.BMP': 'document-add',
  'FILEOPEN.BMP': 'folder-open',
  'FILESAVE.BMP': 'save-as',
  'FIND.BMP': 'search',
  'FIRSTAID.BMP': 'first-aid',
  'FLDR2OPN.BMP': 'folder-open',
  'FLDRMANY.BMP': 'folders',
  'FLDROPEN.BMP': 'folder-open',
  'FLDRSHUT.BMP': 'folder',
  'FLOPPY.BMP': 'save-as',
  'FOLDRDOC.BMP': 'folder',
  'FONT.BMP': 'font',
  'FONTBOLD.BMP': 'font-bold',
  'FONTITAL.BMP': 'font-italic',
  'FONTSIZE.BMP': 'font-size',
  'FORM.BMP': 'form',
  'GEARS.BMP': 'gears',
  'GLOBE.BMP': 'globe',
  'GROUP.BMP': 'group',
  'GRPHBAR.BMP': 'bar-chart',
  'GRPHLINE.BMP': 'line-chart',
  'GRPHPIE.BMP': 'pie-chart',
  'HARDDISK.BMP': 'hard-drive',
  'HELP.BMP': 'help',
  'HELPINDX.BMP': 'help',
  'HIDE.BMP': 'eye-off',
  'HOURGLAS.BMP': 'hourglass',
  'IGNORE.BMP': 'x',
  'IMPORT.BMP': 'arrow-circle-left',
  'INSERT.BMP': 'plus',
  'KEY.BMP': 'key',
  'KEYBOARD.BMP': 'keyboard',
  'LED1OFF.BMP': 'light-bulb-off',
  'LED1ON.BMP': 'light-bulb-on',
  'LED2OFF.BMP': 'light-bulb-off',
  'LED2ON.BMP': 'light-bulb-on',
  'LED3OFF.BMP': 'light-bulb-off',
  'LED3ON.BMP': 'light-bulb-on',
  'LIBRARY.BMP': 'library',
  'LINKS.BMP': 'link',
  'LOCKOPEN.BMP': 'lock-open',
  'LOCKSHUT.BMP': 'lock-closed',
  'MAIL.BMP': 'mail',
  'MAILAUD.BMP': 'mail',
  'MAILBOX.BMP': 'mailbox',
  'MAILBOXF.BMP': 'mailbox',
  'MAILHOT.BMP': 'mail',
  'MAILOPEN.BMP': 'mail-open',
  'MAILPICT.BMP': 'mail',
  'MAILTEXT.BMP': 'mail',
  'MAILVID.BMP': 'mail',
  'MANY2MNY.BMP': 'users',
  'MANY2ONE.BMP': 'user-group',
  'MEAN.BMP': 'calculator',
  'MEDIAN.BMP': 'calculator',
  'MODE.BMP': 'calculator',
  'MONITOR.BMP': 'monitor',
  'MOUSE.BMP': 'mouse',
  'MUSIC.BMP': 'music-note',
  'NETPEER.BMP': 'network',
  'NETSERV.BMP': 'server',
  'NIGHT.BMP': 'moon',
  'NPAD.BMP': 'notepad',
  'NPADTAB.BMP': 'notepad',
  'NPADWRIT.BMP': 'notepad',
  'ONE2MANY.BMP': 'list-bullet',
  'ONE2ONE.BMP': 'user',
  'PAGENUM.BMP': 'document-number',
  'PASTE.BMP': 'clipboard-paste',
  'PENCIL.BMP': 'pencil',
  'PHONE.BMP': 'phone',
  'PHONERNG.BMP': 'phone-outgoing',
  'PICTURE.BMP': 'picture',
  'PRINT.BMP': 'printer',
  'PRINTER.BMP': 'printer',
  'PROPERTY.BMP': 'property',
  'QUERY.BMP': 'search',
  'REPORT.BMP': 'document-report',
  'RESOURCE.BMP': 'resource',
  'RETRY.BMP': 'refresh',
  'SHOW.BMP': 'eye',
  'SORT.BMP': 'sort-ascending',
  'SOUND.BMP': 'volume-up',
  'SOUNDOFF.BMP': 'volume-off',
  'SPELLING.BMP': 'spellcheck',
  'STPWATCH.BMP': 'stopwatch',
  'SUM.BMP': 'calculator',
  'TABLE.BMP': 'table',
  'TIME.BMP': 'clock',
  'TOOLS.BMP': 'tools',
  'TRASH.BMP': 'trash',
  'TRASHFUL.BMP': 'trash',
  'TUTORIAL.BMP': 'book-open',
  'UNDO.BMP': 'arrow-counterclockwise',
  'UNGROUP.BMP': 'user-remove',
  'VARIANCE.BMP': 'calculator',
  'VCRFSFOR.BMP': 'fast-forward',
  'VCRPAUSE.BMP': 'pause',
  'VCRPLAY.BMP': 'play',
  'VCRRECRD.BMP': 'record',
  'VCRREWND.BMP': 'rewind',
  'VCRSTOP.BMP': 'stop',
  'VIDEO.BMP': 'film',
  'WATCH.BMP': 'watch',
  'WRITE.BMP': 'pencil',
  'ZOOMIN.BMP': 'zoom-in',
  'ZOOMOUT.BMP': 'zoom-out'
}
